// Validates profile JSON typed into the code view, with line numbers people can act on.
import { normaliseProfile } from "./profiles/schema.js";

export function lineOfOffset(text, offset) {
  return text.slice(0, offset).split("\n").length;
}

// The line on which each object in the top-level "rules" array starts.
export function ruleLines(text) {
  const start = text.search(/"rules"\s*:\s*\[/);
  if (start < 0) return [];
  const lines = [];
  let depth = 0;
  let inString = false;
  for (let i = text.indexOf("[", start) + 1; i < text.length; i++) {
    const c = text[i];
    if (inString) {
      if (c === "\\") i++;
      else if (c === '"') inString = false;
      continue;
    }
    if (c === '"') inString = true;
    else if (c === "{" || c === "[") {
      if (depth === 0) lines.push(lineOfOffset(text, i));
      depth++;
    } else if (c === "}" || c === "]") {
      if (depth === 0) break;
      depth--;
    }
  }
  return lines;
}

function syntaxProblem(text, error) {
  const message = error.message
    .replace(/^JSON\.parse:\s*/, "")
    .replace(/\s*\(line \d+ column \d+\)/, "")
    .replace(/\s*(in JSON )?at position \d+.*$/s, "")
    .replace(/\s*at line \d+ column \d+ of the JSON data$/, "");
  const lineColumn = /line (\d+) column (\d+)/.exec(error.message);
  const position = /position (\d+)/.exec(error.message);
  const line = lineColumn ? Number(lineColumn[1]) : position ? lineOfOffset(text, Number(position[1])) : 1;
  return { line, message: `JSON syntax error: ${message}` };
}

export function validateProfileJson(text) {
  let data;
  try {
    data = JSON.parse(text);
  } catch (error) {
    return { profile: null, problems: [syntaxProblem(text, error)] };
  }
  const { profile, errors } = normaliseProfile(data);
  const lines = ruleLines(text);
  const problems = errors.map((message) => {
    const rule = /^Rule (\d+):/.exec(message);
    return { line: rule ? lines[Number(rule[1]) - 1] ?? null : null, message };
  });
  return { profile: problems.length ? null : profile, problems };
}
